// extracted by mini-css-extract-plugin
module.exports = {"container":"Section2_container__3C9mP","boxWrapper":"Section2_boxWrapper__3Y4G8","box":"Section2_box__3EsdV"};